<template>
    <div class="newPage">

        <div class="content">
            <div class="VOCNavBar">
                <div class="title">参数选择</div>
                <div class="navBarItem">
                    <div class="navBarTitle">开始日期</div>
                    <div class="navBarValue">
                        <el-date-picker
                                v-model="queryParams.startTime"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="navBarItem">
                    <div class="navBarTitle">结束日期</div>
                    <div class="navBarValue">
                        <el-date-picker
                                v-model="queryParams.endTime"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="navBarItem">
                    <div class="navBarTitle">数据类型</div>
                    <div class="navBarValue">
                        <el-radio-group v-model="queryParams.type">
                            <el-radio :label="0">原始</el-radio>
                            <el-radio :label="1">审核</el-radio>
                            <el-radio :label="2">全部</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="title">选择站点</div>
                <div class="statisticBox">
                    <el-checkbox-group v-model="queryParams.stations">
                        <div v-for="(item,index) in addressList" :key="index">
                            <el-checkbox :label='item'>{{item}}</el-checkbox>
                        </div>
                    </el-checkbox-group>

                </div>
                <div class="btnBox">
                    <el-button type="primary" icon="el-icon-search" size="mini" @click="getList">查询</el-button>
                    <el-button icon="el-icon-refresh" size="mini" @click="excelExport">导出</el-button>
                </div>
                <!--<el-tree-->
                <!--:data="data"-->
                <!--show-checkbox-->
                <!--node-key="id"-->
                <!--:default-expanded-keys="[2, 3]"-->
                <!--:default-checked-keys="[5]">-->
                <!--</el-tree>-->
            </div>
            <div class="showContent">
                <breadcrumb></breadcrumb>
                <div class="VOCContent" v-if="tableData">
                    <div style="padding: 4px;">
                        <el-button type="primary" :disabled="!ids.length" size="mini" @click="handleDetele()">全部删除</el-button>

                    </div>
                    <el-table
                            size="mini"
                            :data="tableData.list"
                            @selection-change="handleSelectionChange"
                            row-key="id"
                            border
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="55">
                        </el-table-column>
                        <el-table-column
                                fixed
                                prop="station"
                                label="站点名称"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                fixed
                                prop="timePoint"
                                label="时间"
                                width="150">
                        </el-table-column>
                        <el-table-column
                                v-for="(item,index) in queryList"
                                :key="index"
                                :prop="item.mname"
                                :label="item.name"
                        >
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="100">
                            <template slot-scope="scope">
                                <el-button @click="handleDetele(scope.row)" type="text" size="small">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <pagination
                            v-show="tableData.totalCount>0"
                            :total="tableData.totalCount"
                            :page.sync="queryParams.page"
                            :limit.sync="queryParams.pageSize"
                            @pagination="getList"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Breadcrumb from "../../../components/breadcrumb";
    function params(obj) {
        let result = '';
        let item;
        for (item in obj) {
            if (obj[item] && String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
        if (result) {
            result = '?' + result.slice(1);
        }
        return result;
    }


    import url from "../../../utils/UrlApi"

    export default {
        name: "dataFind",
        components: {Breadcrumb},
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                queryParams: {
                    stations: [],
                    startTime:'',
                    endTime:'',
                    // startTime: '2021-04-01 00:00:00',
                    // endTime: '2021-04-13 00:00:00',
                    type: 0,
                    page: 1,
                    style:'1',
                    pageSize: 10,

                },
                addressList: [],
                tableData: null,
                queryList: [],
                ids:[]
            }
        },
        created() {
            // this.getqueryList()
            this.getParams()
            this.getaddresstree()
            this.getqueryList()

        },
        methods: {
            getParams() {
                let data = {
                    // style :1
                }
                this.$http.get(url.getSelectUse, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        if (res.data.data) {
                            this.queryParams = res.data.data
                            this.queryParams.stations = res.data.data.stations.split(',')
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getList() {
                let data = JSON.parse(JSON.stringify(this.queryParams))

                data.stations = this.queryParams.stations.join()
                this.$http.get(url.vocDataList, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.tableData = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            //  获取 站点数据
            getaddresstree() {
                let data = {type:1}
                this.$http.get(url.vocDataAddr, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        // console.log(res)
                        this.addressList = res.data.data

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            //  导出
            excelExport() {
                let data = JSON.parse(JSON.stringify(this.queryParams))
                data.token = localStorage.getItem('token')
                data.stations = this.queryParams.stations.join()
                let allUrl = url.excelExport + params(data)
                window.open(allUrl, '_blank')
            },


            getqueryList() {
                let data = {
                    style:1
                }
                this.$http.get(url.vocDatamapping, {params: data}).then(res => {
                    if (res.data.code === '200') {
                        this.queryList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            handleSelectionChange(val){
                // console.log(val)
                let ids = []
                val.forEach(res=>{
                    ids.push(res.id)
                })
                this.ids = ids
            },

            handleDetele(row){
                console.log(row)
                this.$confirm('确认删除此数据?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // let data = {
                    //     ids:row ? [row.id]: this.ids
                    // }

                    let data = row ? [row.id]: this.ids
                    this.$http.post(url.vocDataDelete, data).then(res => {
                        if (res.data.code === '200') {
                            this.getList()
                            this.$message.success('删除成功')
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }).catch(() => {
                });
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../../../assets/vocContent";
</style>